import { EmptyListFallback } from '../EmptyListFallback/EmptyListFallback';
import ChecklistItem from './ChecklistItem';
import type { TabProps } from '../../containers/Checklists/Checklists.models';

function Ended(props: TabProps) {
  const { checklists, onDotsClick, searchText } = props;
  return (
    <div role="endedChecklistsTab">
      {checklists.map(item => (
        <ChecklistItem
          checklist={item}
          key={`Ended-${item.id}`}
          onDotsClick={onDotsClick}
          searchText={searchText}
        />
      ))}
      {checklists.length === 0 && (
        <EmptyListFallback
          listLength={checklists.length}
          isLoading={false}
          searchTerm={searchText}
          emptyListTx={'empty_checklists'}
          emptySearchTx={'messages_not_found_search'}
        />
      )}
    </div>
  );
}

export default Ended;
